import {buildCreatorsArray} from "./buildCreatorsArray.js"

export function grabMainComic(response){

    var comicDetailsArray ;
    

    try{ 
        var comicsDataRetrieved = response.data.data.results[0];
        
            
            //make an array of the characters in the issue. This array will be included in each comicDetailsArray[]
            //turns out this will be done in grabCharacters(), but what the hell
            var characterListData = response.data.data.results[0].characters.items;
            var charactersArray = [];

            characterListData.forEach(function(item,index){
                charactersArray.push(item.name);
            });

            //clean up what you need for a list of creators and positions
            var creatorsListData = response.data.data.results[0].creators.items;

            //external function just to keep this one neater. it takes the creators data and organizes
            //it into something we can use for display later in the render
            var creatorsArray = buildCreatorsArray(creatorsListData);

            comicDetailsArray = [
                response.data.data.results[0].title,
                response.data.data.results[0].description,
                response.data.data.results[0].thumbnail.path + "." +response.data.data.results[0].thumbnail.extension,
                response.data.data.results[0].id,
                response.data.data.results[0].format,
                response.data.data.results[0].pageCount,
                charactersArray,
                creatorsArray
            ]

       
    }
    catch(error) {
        console.log("Couldnt grab a comic in grabComic.js" + error);
    }


 return comicDetailsArray;

}//end grabComic()


// WEBPACK FOOTER //
// ./src/components/includes/grabMainComic.js